import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import BaseRootOption from "%/dynamic-component-editor/classes/base-root-option";

export default class PageTitle extends BaseRootOption {
  static userInterfaceComponent = {
    label: "Title",
    component: inspectorTools.SIMPLE_INPUT,
    useDivider: false,
    useVerticalOrientation: true,
  };

  static defaultValue = "New Page";
}
